<template>
    <dialog-component :dialog="data" @dialogClose="c => c()">
        <section slot="content" :class="shit$(`text-a:c; c:#fff;`)">
            <img :src="`${env$}/static/images/export_to_robot_success.png`" :class="shit$(`w:150px; h:150px; mt:25px;`)"/>
            <!-- <svg-icon :class="shit$(`mt:25px;`)" width="150" height="150" href="#code-lab-export-successful-icon" /> -->
            <section :class="shit$(`text-a:l; py:25px; margin:auto;  w:300px; font:14px; letter-s:1px; lh:1.57; font-w:500;`)">
                <p v-for="(t, i) in data.content" :key="i">{{ t }}</p>
            </section>
        </section>
        <div slot="footer" >
            <section @click="() => {
                mutations.data({ isShow: false })
            }"
            :class="[
                shit$(`bgc:rgba(14, 211, 255, 0.6); cursor:p; c:#fff; font-w:500; font:14px;`),
                shit$(`w:160px; h:48px; radius:32.5px; text-a:c; lh:48px; active:opacity:.6!; margin:auto;`)
            ]">{{this.$t( "code-lab/component/file-management/dialog-notify/dialog-notify.vue_0" ) }}</section>
        </div>
    </dialog-component>
</template>

<script>
import DialogComponent from "@/code-lab/view/organization/s-dialog.vue";
import { store, mutations } from '@/code-lab/component/file-management/dialog-notify/observable.js'
import { mapState } from 'vuex'
export default {
    components: { DialogComponent },
    computed: {
        data () { return store.data },
        ...mapState(["env$"])
    },
    beforeCreate () {
        this.mutations = mutations
    }
}
</script>
